/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Došlo k neznámé chybě. Prosím zkuste později.`
};

const da_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Der opstod en ukendt fejl. Prøv venligst igen senere.`
};

const de_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Ein unbekannter Fehler ist aufgetreten. Bitte versuchen Sie es später erneut.`
};

const en_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `An unknown error occurred. Please try again later.`
};

const es_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Se produjo un error desconocido. Por favor, inténtalo más tarde.`
};

const fr_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Une erreur inconnue s'est produite. Veuillez réessayer plus tard.`
};

const hu_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Ismeretlen hiba történt. Kérjük, próbálkozz később.`
};

const it_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Si è verificato un errore sconosciuto. Riprova più tardi.`
};

const nl_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Er is een onbekende fout opgetreden. Probeer het later opnieuw.`
};

const pl_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Wystąpił nieznany błąd. Spróbuj ponownie później.`
};

const pt_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Ocorreu um erro desconhecido. Por favor, tente novamente mais tarde.`
};

const sv_errors_unknown_message = /** @type {(inputs: {}) => string} */ () => {
	return `Ett okänt fel uppstod. Försök igen senare.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const errors_unknown_message = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.errors_unknown_message(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("errors_unknown_message", locale)
	if (locale === "cs") return cs_errors_unknown_message(inputs)
	if (locale === "da") return da_errors_unknown_message(inputs)
	if (locale === "de") return de_errors_unknown_message(inputs)
	if (locale === "en") return en_errors_unknown_message(inputs)
	if (locale === "es") return es_errors_unknown_message(inputs)
	if (locale === "fr") return fr_errors_unknown_message(inputs)
	if (locale === "hu") return hu_errors_unknown_message(inputs)
	if (locale === "it") return it_errors_unknown_message(inputs)
	if (locale === "nl") return nl_errors_unknown_message(inputs)
	if (locale === "pl") return pl_errors_unknown_message(inputs)
	if (locale === "pt") return pt_errors_unknown_message(inputs)
	return sv_errors_unknown_message(inputs)
};
export { errors_unknown_message as "errors.unknown.message" }